<template>
    <div>
      <b-row class="card">
        <div class="w-100">
          <h5 class="title-card">
            <i class="fas fa-pen"></i> Filtros
          </h5>
        </div>

        <div class="w-100 p-3">
          <b-row>
            <b-col lg="4">
              <b-form-group label="Descrição do Transformador">
                <b-form-input v-model="filters.description"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="2">
              <b-form-group label="Potência (KVA)">
                <b-form-input v-model="filters.potency"></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="4" class="align-btn">
              <b-button variant="info" class="mr-2">Pesquisar</b-button>
              <b-button variant="danger" @click="resetInput">Limpar</b-button>
            </b-col>
          </b-row>
        </div>
      </b-row>
      <b-row class="card mt-5">
        <div class="w-100">
          <h5 class="title-card">
            <i class="fas fa-microchip"></i> Transformadores Cadastrados
          </h5>
        </div>
        <div class="w-100 p-3">
          <b-button variant="primary" :to="{ name: 'transformer-create' }">
            <i class="fas fa-plus"></i> Adicionar novo transformador
          </b-button>
        </div>
        <div class="w-100 p-3">
          <b-table
          id="tb-transformers"
          responsive
          bordered
          :current-page="currentPage"
          :per-page="perPage"
          :busy="load"
          :items="transformers"
          :fields="columsTableTransformers">
            <template #table-busy>
              <div class="text-center text-success my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Carregando...</strong>
              </div>
            </template>
            <template v-slot:cell(actions)="data">
                <div>
                <b-button
                :to="{ name: 'transformer-edit', params: { id: data.item.id } }"
                title="Editar transformador"
                size="sm"
                class="mr-1"
                variant="warning">
                    <i class="fas fa-pencil-alt"></i> Editar
                </b-button>
                <b-button
                title="Excluir transformador"
                size="sm"
                class="mr-1"
                @click="confirmRemove(data.item.id)"
                variant="danger"
                >
                    <i class="fas fa-pencil-alt"></i> Excluir
                </b-button>
                </div>
            </template>
          </b-table>
        </div>

        <div class="w-100 py-3" v-if="totalRows > 15">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          ></b-pagination>
        </div>
      </b-row>
    </div>
  </template>

<script>
import MessagesMixin from '@/mixins/messages-mixin';
import QuestionMixin from '@/mixins/question-mixin';
import TransformerService from '@/Services/TransformerService';

export default {
  data() {
    return {
      id_remove: null,
      columsTableTransformers: TransformerService.getFieldsTableTransformers(),
      load: true,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      transformers: [],
      filters: {
        description: '',
        potency: '',
      },
      payload: {
        description: '',
        kva: '',
        price: '',
      },
    };
  },

  mixins: [MessagesMixin, QuestionMixin],

  methods: {
    async getAll() {
      // const filters = { ...this.filters };

      try {
        const { data } = await TransformerService.getList();
        console.log(data);
        this.totalRows = data.length;
        this.transformers = data.map((item) => ({
          id: item.id,
          description: item.description,
          kva: item.kva,
          price: this.$options.filters.currency(item.price),
        }));
      } catch (error) {
        console.log(error);
      }
      this.load = false;
    },
    confirmRemove(id) {
      this.id_remove = id;
      this.$toast.question(
        'Deseja realmente remover esse transformador ?',
        'Atenção',
        this.getQuestionObj(this.deleteTransformer, '', 'Inversor removido'),
      );
    },
    async deleteTransformer() {
      try {
        await TransformerService.delete(this.id_remove);
        this.getAll();
      } catch (error) {
        console.log(error);
      }
    },
    resetInput() {
      this.filters.description = '';
      this.filters.potency = '';
    },
  },

  created() {
    this.getAll();
  },

};
</script>
